import * as React from 'react'
import type { SvgIconProps } from '@mui/material'
import { BaseIcon } from '../BaseIcon'
export const LogoutIcon = (props: SvgIconProps) => (
  <BaseIcon fill="none" {...props}>
    <path fill="currentColor" d="M16 5.985H6v11.97h10V20H6.03a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2H16z" />
    <path fill="currentColor" d="m16.174 9.128 1.209-1.269 4.11 4.11-4.11 4.112-1.21-1.21L18 13H8.98v-2H18z" />
  </BaseIcon>
)
